import React from "react";

import { AudioRecorder, AudioPlayer } from "utils";

export const AudioButton = props => {
  if (props.savedClip) return <AudioPlayer {...props} />;
  return <AudioRecorder {...props} />;
};
